import React, { ReactNode } from 'react';
import { Card, Text } from '@fluentui/react-components';

import EnhancedExternalLink from 'src/components/atoms/enhanced-external-link/EnhancedExternalLink';
import { ProgramParticipantStatus } from 'src/models/rewards/Rewards';
import RewardProgramStatusDate from 'src/components/molecules/reward-program-status-date/RewardProgramStatusDate';
import { useRewardProgramCardStyles } from './RewardProgramCard.styles';

const viewFullWebLink = 'https://www.google.com/';

interface RewardProgramCardProps {
  programName: string
  programParticipantStatus: ProgramParticipantStatus
  cta?: string
  isProgramTargetReached?: boolean
  children?: ReactNode
}

const setProgramNameReached = (
  programName: string,
  endDate: string,
  completedDate: string | null,
): string => {
  const completionDate = completedDate ? new Date(completedDate) : new Date(0);
  const programEndDate = new Date(endDate);
  const isCompletedEarly = completedDate && completionDate < programEndDate;

  return isCompletedEarly ? programName : `${programName} reached`;
};

const RewardProgramCard: React.FC<RewardProgramCardProps> = ({
  programName,
  cta: callToAction = '',
  children,
  programParticipantStatus,
  isProgramTargetReached,
}) => {
  const classes = useRewardProgramCardStyles();
  const { endDate, programTypeStatus: { completedDate } } = programParticipantStatus;
  const currentProgramName = isProgramTargetReached
    ? setProgramNameReached(programName, endDate, completedDate)
    : programName;

  return (
    <Card>
      <div className={classes.header}>
        <Text className={classes.programName}>
          {currentProgramName}
        </Text>

        <RewardProgramStatusDate programParticipantStatus={programParticipantStatus} />
      </div>

      <div>{children}</div>

      <div className={classes.footer}>
        <EnhancedExternalLink as="a" href={viewFullWebLink}>{callToAction}</EnhancedExternalLink>
      </div>
    </Card>
  );
};
export default RewardProgramCard;
